import styles from "./panelHero.module.css";

export default function PanelHero({ icon, title, subtitle }) {
  return (
    <div className={styles.panelHero}>
      {icon && (
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
      )}
      <div className={styles.text}>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
    </div>
  );
}
